/*
 * @Description:
 * @Author: xiaoHai
 * @Date: 2021-10-14 10:56:20
 * @LastEditTime: 2021-10-14 10:58:36
 */
import Vue from 'vue';
import Router from 'vue-router';

import Home from '../pages/Home.vue';
import Product from '../pages/Product.vue';
import About from '../pages/About.vue';
import Join from '../pages/Join.vue';
import Business from '../pages/Business.vue';
import Privacy from '../pages/Privacy.vue';
import Privacy233 from '../pages/Privacy233.vue';
import Privacy2 from '../pages/Privacy2.vue';
import productLis from '../pages/paoductList.vue';
import rotation from '../pages/components/rotation.vue';
import aboutGame from '../pages/AboutGame.vue';
import agreement from '../pages/Agreement.vue';
import recharge from '../pages/Recharge.vue';
import PrivacyHw from '../pages/PrivacyHw.vue';
import UserPrivacy from '../pages/UserPrivacy.vue';
Vue.use(Router);

export default new Router({
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0,
            };
        }
    },
    routes: [
        {
            path: '/',
            redirect: '/home',
        },
        {
            path: '/home',
            component: Home,
        },
        {
            path: '/product',
            component: Product,
        },
        {
            path: '/about',
            component: About,
        },
        {
            path: '/join',
            component: Join,
        },
        {
            path: '/business',
            component: Business,
        },
        {
            path: '/privacy',
            component: Privacy,
        },
        {
            path: '/privacy233',
            component: Privacy233,
        },
        {
            path: '/privacy2',
            component: Privacy2,
        },
        {
            path: '/productList',
            component: productLis,
        },
        {
            path: '/rotation',
            component: rotation,
        },
        {
            path: '/aboutGame',
            component: aboutGame,
        },
        {
            path: '/agreement',
            component: agreement,
        },
        {
            path: '/recharge',
            component: recharge,
        },
        {
            path: '/privacyHw',
            component: PrivacyHw,
        },
        {
            path: '/userPrivacy',
            component: UserPrivacy,
        },
    ],
});
